import React, { useCallback, useState, useRef } from 'react';
import DataGrid, {
  Column,
  DataGridTypes,
  Scrolling,
  SearchPanel,
  Selection,
} from 'devextreme-react/data-grid';
import DropDownBox from 'devextreme-react/drop-down-box';

//const dropDownOptions = { width: 550 };
const ownerLabel = { 'aria-label': 'Relation' };

export const RelationDropDownBoxComponent = (props) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([props.data.value]);
  const dropDownBoxRef = useRef<DropDownBox>(null);

  const contentRender = useCallback(() => {
    const onSelectionChanged = (args: DataGridTypes.SelectionChangedEvent) => {
      setSelectedRowKeys(args.selectedRowKeys);

      // Close the dropdown using the instance method
      if (dropDownBoxRef.current) {
        dropDownBoxRef.current.instance.close();
      }

      props.data.setValue(args.selectedRowKeys[0]);
    };

    return (
      <DataGrid
        dataSource={props.data.column.lookup.dataSource}
        remoteOperations
        height={350}
        selectedRowKeys={selectedRowKeys}
        hoverStateEnabled
        onSelectionChanged={onSelectionChanged}
        focusedRowEnabled
        defaultFocusedRowKey={selectedRowKeys[0]}>
        <SearchPanel
          visible
          width={240}
          placeholder='Zoeken...' />
        <Column caption='Nr' width={90} dataField='CustomerNumber' />
        <Column caption='Naam' dataField='Name' sortOrder='asc' />
        <Column caption='Adres'
          calculateCellValue={(row: Record<string, string>) => `${row.Address || ''} ${row.AddressNr || ''}`.trim()} />
        <Column caption='Stad' dataField='City' />
        <Scrolling mode='virtual' />
        <Selection mode='single' />
      </DataGrid>
    );
  }, [props.data, selectedRowKeys]);

  return (
    <DropDownBox
      ref={dropDownBoxRef}
      placeholder='Kiezen...'
      dataSource={props.data.column.lookup.dataSource}
      value={selectedRowKeys[0]}
      displayExpr='Name'
      valueExpr='Oid'
      inputAttr={ownerLabel}
      contentRender={contentRender} />
  );
};

